import { ProductDeliveryPromiseExplanations, ProductTileVerticalFormat } from './product-detail/ProductTypes';
import { ProductLister } from './product-lister/ProductTypes';

export type SingleProductTileOwnProps = {
  analyticsBannerId?: string;
  tileFormat: ProductTileVerticalFormat;
  deliveryPromiseExplanations: ProductDeliveryPromiseExplanations;
  initializationProduct: ProductLister;
  withoutSpacing?: boolean;
  shouldInitProduct?: boolean;
  products?: Array<{
    productCode: string;
    productColor?: string;
  }>;
  shortDescription?: string;
  pros?: Array<string>;
  cons?: Array<string>;
  adjustTileDescriptionHeight?: boolean;
  isFallbackProduct?: boolean;
};
